@if (canShowLoader) {
<div class="loader-overlay">
  <div class="loader-overlay-content">
    <mat-spinner></mat-spinner>
  </div>
</div>
}
